import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CountryCodeService } from '../../../api/services/country-code.service';

@Component({
    selector: 'app-phone-number',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './phone-number.component.html',
    styleUrl: './phone-number.component.css'
})
export class PhoneNumberComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() labelAbove: any;
  errors: { [key: string]: string } = {};
  countryResponse: any[] = [];
  selectedCodes: { [key: string]: string } = {};
  dropdownOpen: any;
  selectedCode: any;
  dropdownPosition: 'top' | 'bottom' = 'bottom';
  constructor(
    private eRef: ElementRef,
    private countryCodeService: CountryCodeService,
  ) {}
  ngOnInit() {
    this.getCountryCode();
  }

  getCountryCode() {
    this.countryResponse = this.countryCodeService.getAll();
  }

  get control() {
    return this.formGroup?.get(this.fields.fieldName);
  }

  /** Function to show the validation error message on enter of the text */
  onKeyUpValidateFields(field: any): void {
    const fieldName = field.fieldName;
    const control = this.formGroup.get(fieldName);
    if (!control) return;
    control.markAsTouched();
    control.updateValueAndValidity({ emitEvent: false });
    this.errors[fieldName] = '';
    if (control.hasError('minlength')) {
      const minLengthRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'minlength',
      );
      this.errors[fieldName] =
        minLengthRule?.error ||
        `Minimum length is ${control.errors?.['minlength']?.requiredLength}.`;
      return;
    }

    if (control.hasError('maxlength')) {
      const maxLengthRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'maxlength',
      );
      this.errors[fieldName] =
        maxLengthRule?.error ||
        `Maximum length is ${control.errors?.['maxlength']?.requiredLength}.`;
      return;
    }

    if (control.hasError('pattern')) {
      const regexRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'regex',
      );
      this.errors[fieldName] = regexRule?.error || 'Invalid format.';
      return;
    }

    if (control.hasError('email')) {
      this.errors[fieldName] = 'Enter a valid email address.';
      return;
    }

    if (control.hasError('min')) {
      const minRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'min',
      );
      this.errors[fieldName] =
        minRule?.error || `Minimum value is ${control.errors?.['min']?.min}.`;
      return;
    }

    if (control.hasError('max')) {
      const maxRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'max',
      );
      this.errors[fieldName] =
        maxRule?.error || `Maximum value is ${control.errors?.['max']?.max}.`;
      return;
    }
    this.errors[fieldName] = '';
  }

  onCodeChange(code: any, fieldName: string): void {
    this.selectedCodes[fieldName] = code;
    this.dropdownOpen = null;
  }

  getFullPhone(fieldName: string): string {
    const control = this.formGroup.get(fieldName);
    const rawPhone = control?.value || '';
    const code = this.selectedCodes[fieldName];
    return code ? code + rawPhone : rawPhone;
  }

  // toggleDropdown(fieldName: string) {
  //   if (this.dropdownOpen === fieldName) {
  //     this.dropdownOpen = null;
  //   } else {
  //     this.dropdownOpen = fieldName;
  //   }
  // }

  dropdownStyle: any = {};

  toggleDropdown(fieldName: string, event: MouseEvent) {
    const button = event.currentTarget as HTMLElement;

    if (this.dropdownOpen === fieldName) {
      this.dropdownOpen = null;
      return;
    }

    const rect = button.getBoundingClientRect();

    const dropdownHeight = 200;

    const spaceBelow = window.innerHeight - rect.bottom;
    const openTop = spaceBelow < dropdownHeight;

    this.dropdownStyle = {
      left: `${rect.left}px`,
      width: `${Math.max(rect.width, 220)}px`,
      position: 'fixed',
      zIndex: 9999,
      ...(openTop
        ? { bottom: `${window.innerHeight - rect.top + 4}px` }
        : { top: `${rect.bottom + 4}px` }),
    };

    this.dropdownOpen = fieldName;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.dropdownOpen = null;
    }
  }
}
